module.exports = __webpack_public_path__ + "img/company12.78ad4878.png";